<template>
  <div class="scale-screen-container">
    <div class="scale-screen-content" :style="contentStyle">
      <slot />
    </div>
  </div>
</template>

<script>
/**
 * 大屏自适应缩放容器
 * 用法：<scale-screen :width="1920" :height="1080" :full-screen="true"> ... </scale-screen>
 * - full-screen=false：等比缩放并居中（保持设计比例，可能留黑边）
 * - full-screen=true：按宽高分别缩放铺满视口（不保持比例）
 */
export default {
  name: 'ScaleScreen',
  props: {
    width: { type: Number, default: 1920 },
    height: { type: Number, default: 1080 },
    fullScreen: { type: Boolean, default: false }
  },
  data() {
    return { scaleX: 1, scaleY: 1 }
  },
  computed: {
    contentStyle() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        transform: `scale(${this.scaleX}, ${this.scaleY})`,
        transformOrigin: 'left top'
      }
    }
  },
  mounted() {
    this.resize()
    window.addEventListener('resize', this.resize)
    // 进入大屏：禁用页面滚动条，避免 100vw/100vh 把滚动条宽度算进去
    // 导致右下角露出 body 浅灰背景（白边）
    this._prevHtmlOverflow = document.documentElement.style.overflow
    this._prevBodyOverflow = document.body.style.overflow
    document.documentElement.style.overflow = 'hidden'
    document.body.style.overflow = 'hidden'
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.resize)
    document.documentElement.style.overflow = this._prevHtmlOverflow || ''
    document.body.style.overflow = this._prevBodyOverflow || ''
  },
  methods: {
    resize() {
      const w = window.innerWidth || this.width
      const h = window.innerHeight || this.height
      if (this.fullScreen) {
        this.scaleX = w / this.width
        this.scaleY = h / this.height
      } else {
        const s = Math.min(w / this.width, h / this.height)
        this.scaleX = s
        this.scaleY = s
      }
    }
  }
}
</script>

<style scoped>
.scale-screen-container {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  /* 深色兜底：即便存在 1px 缝隙也显示为深蓝而非浅灰 */
  background-color: #061226;
}
.scale-screen-content {
  position: absolute;
  left: 0;
  top: 0;
}
</style>
